import { useDroppable } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import Game from "./Game";

const Round = ({ bracketLevel, roundId, gameIds, gameNumbers }) => {
  const { setNodeRef } = useDroppable({
    roundId,
  });

  return (
    <SortableContext
      id={roundId}
      items={gameIds}
      strategy={verticalListSortingStrategy}
    >
      <div ref={setNodeRef} className="flex flex-col justify-around">
        {gameIds.map((gameId) => {
          return (
            <Game
              key={gameId}
              gameId={gameId}
              bracketLevel={bracketLevel}
              roundId={roundId}
              gameNumbers={gameNumbers}
            />
          );
        })}
      </div>
    </SortableContext>
  );
};

export default Round;
